import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const jiraBusinessSummaryEmbedRoute: InvariantJiraRoute = {
	name: 'classic-business-summary-embed',
	path: '/jira/core/projects/:projectKey/summary/embed',
	exact: true,
};
